import { getHistory, PATCH_HISTORY } from '../../components/NotificationsHistory/actions'
import { newToast } from '../../components/shared/toast-stack/actions'
import http from '../http'
import { getStore } from '../state'
import { getIdToken, waitForToken } from '../token-utils'
import NchanSubscriber from '../vendor/NchanSubscriber'

import { handleIncomingMessageNotification, handleAlertNotification } from './handle-notification'

let subscriber = null

export const stopPubsubListening = () => {
  if (!subscriber) {
      // This is normal when no subscriber was started
    return
  }

  try {
    subscriber.stop()
  } catch (err) {
    console.error(err)
  }

  subscriber = null
}

export const startPubsubListening = () => {
    console.log('startPubsubListening called - current subscriber:', subscriber)

  if (subscriber) {
    console.info('PubSub subscriber already initialized')
    return
  }

    const listenUrl = `${http.BASE_URL}/listen`
    console.log('Creating new NchanSubscriber for:', listenUrl)

    subscriber = new NchanSubscriber(listenUrl, {
    subscriber: 'longpoll',
    reconnect: 'persist',
    shared: true
  })

  subscriber.on('transportNativeBeforeCreate', (transport, name, cb) => {
    if (name !== '__slave') {
      // First try to get the token immediately
      getIdToken()
        .then(idToken => {
          transport.headers.Authorization = `Bearer ${idToken}`
          cb()
        })
        .catch(e => {
          console.info('Token not immediately available, waiting up to 3 seconds:', e.message)
          // If token not available, wait up to 3 seconds for it
          waitForToken(3000)
            .then(idToken => {
              transport.headers.Authorization = `Bearer ${idToken}`
              cb()
            })
            .catch(waitError => {
              console.warn('Token still not available after waiting, continuing without auth:', waitError.message)
              // Let the transport continue without auth - server will handle appropriately
              cb()
            })
        })
    } else {
      cb()
    }
  })

  subscriber.on('message', (msgStr /* , messageMetadata */) => {
    if (msgStr && msgStr.length > 0) {
      const notif = JSON.parse(msgStr)

      const store = getStore()

      if (notif.type === 'chat_message') {
        handleIncomingMessageNotification(notif.payload)
          .catch((error) => {
            console.error(error)
          })

        return
      }

      store.dispatch({
        type: PATCH_HISTORY,
        notifications: [ notif ]
      })

      switch (notif.type) {
        case 'patient_ineligible':
          store.dispatch(newToast({
            ...notif.payload,
            type: notif.type
          }))
          break
        case 'alert_escalated':
        case 'alert_owned': {
          handleAlertNotification(notif.payload, { showAlert: notif.type === 'alert_escalated' })
          break
        }
        case 'symptoms_reported':
        case 'issue_assigned':
        case 'igao_published':
        case 'new_file':
          store.dispatch(newToast(notif))
          break
        default:
          console.error('Received notification with unknown type', notif)
      }

      if (notif.history) {
        store.dispatch(getHistory())
      }
    }
  })

  subscriber.on('error', error => {
    if (error === 403 || error === 401) {
      setTimeout(() => {
        stopPubsubListening()
        startPubsubListening()
      }, 500)
    }
  })

  subscriber.start()
    console.log('PubSub subscriber.start() called - long polling should begin')
}
